<footer class="footer text-center text-sm-start d-print-none">
  <div class="container-fluid px-0">
    <div class="footer-shell">
      <p class="mb-1 footer-label">Realização</p>
      <img
        [src]="sponsorStripSrc"
        alt="Regua horizontal com os patrocinadores do projeto Lista Vermelha"
        class="footer-sponsors-image"
      />
    </div>
  </div>
</footer>
